import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	signal,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { RoomCardFacilitiesInterface } from '@valk-nx/rooms-store/rooms.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'vp-room-facilities',
	templateUrl: './room-facilities.component.html',
	imports: [AngularSvgIconModule, TranslatePipe],
})
export class RoomFacilitiesComponent {
	readonly facilities = input.required<RoomCardFacilitiesInterface>();
	readonly maxNumberOfGuests = input.required<number>();
	readonly roomSurface = input.required<number>();
	readonly babyBeds = input(0);
	readonly roomIndex = input(0);
	readonly showMoreInformationAccordion = input(false);

	readonly allFacilities = computed<string[]>(() => [
		...this.facilities().sleepingComfort,
		...this.facilities().bathroom,
		...this.facilities().misc,
	]);

	readonly showAdditonalInformation = signal(false);

	toggleAdditionalInformation() {
		this.showAdditonalInformation.update((value) => !value);
	}
}
